export function getPaymentChannelV3(send) {
  return (payeeId, paymentChannelId, query, ...args) =>
    send(
      {
        path: '/v3/payees/{payeeId}/paymentChannels/{paymentChannelId}',
        pathParameters: { payeeId, paymentChannelId },
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
